import { render, staticRenderFns } from "./global-alert.vue?vue&type=template&id=53429ef8&scoped=true&"
import script from "./global-alert.vue?vue&type=script&lang=js&"
export * from "./global-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53429ef8",
  null
  
)

export default component.exports